import { createBrowserHistory } from "history";
// import { config } from "./config";

const history = createBrowserHistory({
  // basename: config.historyBaseName,
  // forceRefresh: true,
});

export default history;
